import { connect } from 'react-redux'
import get from 'lodash/get';

import {
  setRequestDownloadReports as onSetRequestDownloadReports,
  downloadReport as onDownloadReport,
  clearDownloadReports as onClearDownloadReports,
} from '../../actions/downloadReportsActions'

const mapStateToProps = state => ({
  downloadReportsDataState: state.downloadReports.dataState,
  downloadReportsData: get(state, ['downloadReports', 'data'], []),
  downloadReportsErrors: get(state, ['downloadReports', 'errors'], []),
  downloadReportsFormat: get(state, ['downloadReports', 'format'], null)
})

const mapDispatchToProps = {
  onSetRequestDownloadReports,
  onDownloadReport,
  onClearDownloadReports
}

const withDownloadReports = Component => connect(mapStateToProps, mapDispatchToProps)(Component)

export { withDownloadReports }